<template>
  <div class="row Footer">
    <div class="col">
      <button class="btn" @click="Home()">
        <i class="fas fa-home"></i><br><span>首頁</span>
      </button>
    </div>
    <div class="col" v-show="Global.User && Global.isGuest != true">
      <button class="btn" @click="User()">
        <i class="fa-solid fa-user"></i><br><span>會員</span>
      </button>
    </div>
    <div class="col" v-if="false" v-show="Global.User && Global.isGuest != true && Shop.customerType != 'Guest'">
      <button class="btn" @click="GroupbuyTip()">
        <i class="fa-solid fa-user-group"></i><br><span>揪團</span>
      </button>
    </div>
    <div class="col">
      <!-- 結帳按鈕一律可點，點擊時依狀態顯示訊息（暫停／公休／不在線等） -->
      <button class="btn" :class="{'shopOffline': !shopOnline}" @click="Cart()">
        <span v-if="shopOnline"><i class="fas fa-cart-plus"></i></span>
        <span v-else><i class="fa-solid fa-spinner"></i></span>
        <br>
        <span v-if="this.$parent.$data.cartPrice == 0">{{shopStatus}}</span>
        <span v-else>${{this.$parent.$data.cartPrice}}</span>
        <div v-if="this.$parent.$data.cartLength > 0" :class="[this.$parent.$data.cartLength > 99 ? 'cartLengthMax' : 'cartLength']">
          {{this.$parent.$data.cartLength}}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'
import { Groupbuy } from '@/mixins/Groupbuy'
import SocketService from '@/Service/SocketService'
import { createGuest } from '@/Service/APIService'

export default {
  name: "Checkout",
  mixins: [Groupbuy],
  props: {
    Shop: Object,
  },
  /** 元件資料：注入 Global 供模板使用 */
  data() {
    return { Global: Global }
  },
  computed: {
    /** 店家是否在線（有 Token 時視為在線）；用於結帳按鈕樣式與可否結帳 */
    shopOnline() {
      if (this.$route.params.Token) return true
      return SocketService.getShopOnline(this.$props.Shop?.id)
    },
    /** 結帳按鈕顯示文字：結帳／暫停／讀取中／不在線 */
    shopStatus() {
      if (this.$route.params.Token) return "結帳"
      if (this.Shop?.orderStatus != "正常") return "暫停"
      if (SocketService.isShopLoading(this.$props.Shop?.id)) return "讀取中"
      return this.shopOnline ? "結帳" : "不在線"
    }
  },
  /** 元件卸載時取消監聽該店家在線狀態 */
  beforeUnmount() {
    if (this.$props.Shop?.id) SocketService.unwatchShop(this.$props.Shop.id)
  },
  watch: {
    Shop: {
      /** 店家變更時：取消舊店家監聽並重新初始化（訂閱新店家） */
      handler(newVal, oldVal) {
        if (oldVal?.id && oldVal.id !== newVal?.id) SocketService.unwatchShop(oldVal.id)
        this.init()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /** 初始化：訂閱店家在線狀態；有 Token、無店家或非正常接單時不訂閱 */
    init: function() {
      if (this.$route.params.Token) return
      const shopId = this.$props.Shop?.id
      if (!shopId) return
      if (this.Shop?.orderStatus != "正常") return
      SocketService.watchShop(shopId)
    },
    /** 前往結帳頁面；按鈕一律可點，點擊時依狀態顯示訊息（暫停／公休／不在線等） */
    Cart: async function() {
      const showShopError = async (message) => {
        await swal.alertError(message)
        this.$parent.$refs.Navbar.Store()
      }

      const now = this.$moment()
      const openingMoment = this.$moment(this.Shop.openingTime, "HH:mm")
      const closingMoment = this.$moment(this.Shop.closingTime, "HH:mm")

      const shopChecks = [
        { ok: this.Shop.orderStatus !== "暫停", message: Global.MESSAGE.CART.SHOP_ORDERSTATUS_PAUSED },
        { ok: this.Shop.orderStatus !== "公休", message: Global.MESSAGE.CART.SHOP_ORDERSTATUS_DAYOFF },
        { ok: !now.isAfter(closingMoment) && !now.isBefore(openingMoment), message: Global.MESSAGE.CART.SHOP_ORDERSTATUS_NORMAL },
        { ok: this.shopOnline, message: Global.MESSAGE.CART.SHOP_NOT_ONLINE }
      ]
      for (const { ok, message } of shopChecks) {
        if (!ok) {
          await showShopError(message)
          return
        }
      }

      if (this.$parent.$data.Cart[0].Data.length === 0) {
        swal.alertError(Global.MESSAGE.CART.CART_NOTHING)
        return
      }

      const customerType = this.$props.Shop.customerType
      const proceed = await this.handleCustomerType(customerType)
      if (!proceed) return

      Global.Cart = this.$parent.$data.Cart
      if (this.$route.params.Token) {
        if (Global.isGuest === true) {
          return swal.confirm("遊客不允許點餐，是否登入？", () => { this.$router.push({ name: "Login" }) })
        }
        this.$router.push({ name: "Cart", query: { Token: this.$route.params.Token } })
      } else {
        this.$router.push({ name: "Cart" })
      }
    },
    /** 依接客模式（User／Guest／都支持）處理登入／遊客邏輯；回傳 true 可繼續結帳，false 表示已顯示錯誤並應 return */
    handleCustomerType: async function(customerType) {
      const goLogin = () => {
        Global.Cart = this.$parent.$data.Cart
        this.$router.push({ name: "Login" })
      }
      const goShop = () => {
        Global.Cart = this.$parent.$data.Cart
        this.$router.push({ path: `/Shop/${Global.Shop.id}` })
      }
      const createGuestAndBind = async () => {
        if (Global.isGuest !== true) {
          const Name = '遊客' + Math.floor(Math.random() * 100)
          const guest = await createGuest({ Name })
          Global.isGuest = true
          Global.User = { id: guest.data.guestId, phone: null, Email: null, Name, Gender: "以上皆非" }
          localStorage.setItem('UserJWT', guest.data.token)
        }
        this.$parent.$data.Cart[0].User.userId = Global.User.id
      }

      if (customerType === 'User') {
        if (!this.userIsLogin()) {
          swal.alertError(Global.MESSAGE.USER.NOT_LOGIN, goLogin)
          return false
        }
        return true
      }

      if (customerType === 'Guest') {
        if (this.$props.Shop.allowGuest === false) {
          swal.alertError(Global.MESSAGE.ERROR.MESSAGE)
          return false
        }
        if (!this.userIsLogin()) {
          await createGuestAndBind()
          return true
        }
        swal.alertError(Global.MESSAGE.CART.ONLY_ALLOW_GUEST, goShop)
        return false
      }

      // 都支持
      if (!this.userIsLogin()) {
        if (this.$props.Shop.allowGuest === false) {
          swal.alertError(Global.MESSAGE.USER.NOT_LOGIN, goLogin)
          return false
        }
        await createGuestAndBind()
      }
      return true
    },
    /** 是否為已登入會員（非遊客、且 Global.User 存在） */
    userIsLogin: function() {
      if (Global.isGuest == null || Global.isGuest == true) return false

      return Global.User == null ? false : true
    },
    /** 前往首頁 */
    Home: function() {
      this.$router.push({ name: "Home" })
    },
    /** 已登入則前往會員頁，否則前往登入頁 */
    User: function() {
      this.userIsLogin() ? this.$router.push({ name: `User` }) : this.$router.push({ name: "Login" })
    },
  },
  /** 掛載時訂閱店家在線狀態 */
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.Footer {
  position: fixed;
  bottom: 0;
  margin: 0;
  text-align: center;
  width: 100%;
  height: 70px;
  background-color: #5599FF;
  > .col {
    padding: 0px;
    > .btn {
      border: 0px;
      background-color: #5599FF;
      box-shadow: 0px 0px 0px 0px;
      color: #FFFFFF;
      font-size: 20px;
      font-weight: 900;
      > .fas {
        margin-bottom: 3px;
        font-size: 24px;
      }
      > .cartLength {
        position: absolute;
        color: white;
        font-size: 17px;
        background-color: red;
        width: 23px;
        height: 23px;
        line-height: 23px;
        left: 88%;
        top: -12px;
        text-align: center;
        -webkit-border-radius: 24px;
        border-radius: 24px;
      }
      > .cartLengthMax {
        position: absolute;
        color: white;
        font-size: 17px;
        background-color: #0066FF;
        width: 53px;
        height: 23px;
        line-height: 23px;
        left: 88%;
        top: -12px;
        text-align: center;
        -webkit-border-radius: 24px;
        border-radius: 24px;
      }
    }
    > .shopOffline {
      color: #444444;
    }
  }
}
@media (max-width: 480px) {
  .Footer {
    > .col {
      > .btn {
        > .cartLengthMax {
          left: 85%;
          top: -17px;
        }
      }
    }
  }
}
</style>